import React from 'react'
import Dashboard from './Dashboard';

function DashboardPage() {
    return ( 
        <div className = "container-fluid">
        <Dashboard />
        </div>
     );
}

export default DashboardPage;